import {http} from '@/utils';

export interface CardListItemType {
  accountName?: string;
  accountNumber?: string | '';
  ifscCode?: string;
  upiId?: string;
  userEmail?: string;
  id?: string;
  img?: string;
}

export const getBankList = () => {
  return http.post<null, CardListItemType[]>('app/card/info');
};

export const onWithdraw = (data: {cardId: string; price: number}) => {
  return http.post('app/pay/paid', data);
};

export interface WithdrawNewInfoType {
  cashBalance: number;
  withdrawableBalance: number;
  dailyWithdrawLimit: number;
  dailyWithdrawTimes: number;
  wageringRequirement: number;
  withdrawFeeRate: number;
}

// 提现页面-所需信息
// /user/withdraw/info
export const getWithdrawInfo = () => {
  return http.post<null, WithdrawNewInfoType>('app/user/withdraw/info');
};
